import React from 'react'

const PROPERTY_ROOM_PRINT_STYLES = `
  .property-room-chain-print {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    padding: 0 12px !important;
    margin: 0 !important;
    font-family: system-ui, -apple-system, sans-serif;
    color: #000;
  }
  .property-room-chain-print .property-room { padding-left: 0 !important; padding-right: 0 !important; }
  .property-room-chain-print .row { display: flex; flex-wrap: wrap; margin-right: -8px; margin-left: -8px; box-sizing: border-box; }
  .property-room-chain-print .col-4 { flex: 0 0 33.333%; max-width: 33.333%; padding: 0 8px; box-sizing: border-box; }
  .property-room-chain-print .col-7 { flex: 0 0 58.333%; max-width: 58.333%; padding: 0 8px; box-sizing: border-box; }
  .property-room-chain-print .col-8 { flex: 0 0 66.666%; max-width: 66.666%; padding: 0 8px; box-sizing: border-box; }
  .property-room-chain-print h6 { margin: 0 10px 0 0; width: 80px; text-align: right; color: #000; font-weight: 600; font-size: 14px; }
  .property-room-chain-print span { text-align: left; font-size: 14px; }
  .property-room-chain-print .d-flex { display: flex; align-items: center; }
  .property-room-chain-print .prop-legend { font-size: 18px !important; font-weight: 600; color: #001f3f; border: none; padding: 0; margin-bottom: 8px; width: auto; }
  .property-room-chain-print .prop-td { font-size: 14px !important; color: #001f3f !important; font-weight: 600 !important; margin: 0; }
  .property-room-chain-print p { margin: 2px 0 0; font-size: 14px; }
  .property-room-chain-print table { width: 100% !important; max-width: 100% !important; table-layout: fixed !important; border-collapse: collapse !important; margin-top: 12px; box-sizing: border-box; }
  .property-room-chain-print table th,
  .property-room-chain-print table td { border: 1px solid #000 !important; padding: 8px; word-wrap: break-word; overflow-wrap: break-word; box-sizing: border-box; vertical-align: top; }
  .property-room-chain-print .table-row { display: table-row !important; }
  .property-room-chain-print .table-cell { display: table-cell !important; flex: none !important; }
  .property-room-chain-print .master-table th { color: #000 !important; font-weight: 500 !important; font-size: 12px !important; }
  .property-room-chain-print .text-list { color: #000 !important; font-weight: 600; font-size: 12px; }
  .property-room-chain-print fieldset { border: none; padding: 0; margin: 0 0 16px; min-width: 0; }
  .property-room-chain-print hr { margin: 12px 0; border-color: #ccc; }
  .property-room-chain-print .img-box {
    width: 150px;
    height: 140px;
    flex-shrink: 0;
    background: #ddd;
    border: 1px solid #ccc;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .property-room-chain-print .picture {
    width: 150px !important;
    height: 140px !important;
    background: #ddd !important;
    display: block;
    object-fit: contain;
    border: none;
    border-radius: 4px;
    box-sizing: border-box;
  }
  @media print {
    .property-room-chain-print { padding: 0 8px !important; }
    .property-room-chain-print table { page-break-inside: auto; }
    .property-room-chain-print tr { page-break-inside: avoid; }
  }
`;

const ChainOfModel = (props) => {

  const { componentRefnew, chainreport, propertyRoomPrint } = props



  if (!chainreport) {
    return null; // or a loading spinner or placeholder content
  }




  const printHostStyle = propertyRoomPrint
    ? { position: 'absolute', left: '-9999px', top: 0, zIndex: -1, visibility: 'visible' }
    : undefined;

  return (
    <div style={printHostStyle} aria-hidden={propertyRoomPrint ? 'true' : undefined}>
      <div className="modal fade" style={{ background: "rgba(0,0,0, 0.5)" }} id="ChainCustodyModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="false">
        <div className="modal-dialog modal-dialog-centered modal-xl rounded modal-dialog-scrollable">
          <div className="modal-content">
            <button type="button" className="border-0 text-red" aria-label="Close" data-dismiss="modal" style={{ alignSelf: "end" }} ><b>X
            </b>
            </button>
            <div className="modal-body ">
              <div classNameName="col-12 col-md-12 col-lg-12 " style={{ marginTop: '-15px' }}>
                <fieldset >
                  <legend className='prop-legend'>Chain Of Custody Report</legend>
                  <div classNameName="row " >
                    <div className={`container${propertyRoomPrint ? ' property-room-chain-print' : ''}`} ref={componentRefnew}>
                      {propertyRoomPrint && <style>{PROPERTY_ROOM_PRINT_STYLES}</style>}
                      <div className="property-room px-3">
                        <div className="row">
                          <div className="col-4 col-md-3 col-lg-2 mt-2">
                            <div
                              className="img-box"
                              style={propertyRoomPrint ? { width: '150px', height: '140px', background: '#ddd', border: '1px solid #ccc', borderRadius: '4px', overflow: 'hidden' } : undefined}
                            >
                              <img
                                src={chainreport?.Agency_Photo || ''}
                                className='picture'
                                style={{
                                  width: '150px',
                                  height: '140px',
                                  ...(propertyRoomPrint ? { background: '#ddd', objectFit: 'contain', boxSizing: 'border-box' } : {}),
                                }}
                                onError={propertyRoomPrint ? (e) => { e.currentTarget.onerror = null; e.currentTarget.removeAttribute('src'); } : undefined}
                              />
                            </div>
                          </div>
                          <div className="col-8 col-md-9 col-lg-10">
                            <div className="row mt-3">
                              <div className="col-7 d-flex justify-content-center">
                                <h6>Agency:</h6>
                                <span>{chainreport.Agency_Name}</span>
                              </div>
                              <div className="col-7 d-flex justify-content-center">
                                <h6>Phone:</h6>
                                <span>{chainreport.Agency_Phone}</span>
                              </div>
                              <div className="col-7 d-flex justify-content-center">
                                <h6>Fax:</h6>
                                <span>{chainreport.Agency_Fax}</span>
                              </div>
                              <div className="col-7 d-flex justify-content-center">
                                <h6>Address:</h6>
                                <span>{chainreport.Agency_Address1}</span>
                              </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      <hr />
                      {/* Article info */}
                      {chainreport.Property[0].Type === 'Article' && (
                        <>
                          <div className="property-info px-0">
                            <fieldset>
                              <legend className='prop-legend px-0'>Evidence Property Information</legend>
                              <table className="table table-bordered mt-3">
                                <tbody>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Property No:</span>
                                      <p>{chainreport.Property[0].PropertyNumber}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Property Type:</span>
                                      <p>{chainreport.Property[0].Type}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Reported Date:</span>
                                      <p>{chainreport.Property[0].ReportedDtTm}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Incident No:</span>
                                      <p>{chainreport.Property[0].IncidentNumber}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Loss Code:</span>
                                      <p>{chainreport.Property[0].LossCode_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Owner Name:</span>
                                      <p>{chainreport.Property[0].OwnerDescription || 'N/A'}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Category:</span>
                                      <p>{chainreport.Property[0].Category_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Classification:</span>
                                      <p>{chainreport.Property[0].Classification_Description || 'N/A'}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Brand:</span>
                                      <p>{chainreport.Property[0].Brand}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Top Color:</span>
                                      <p>{chainreport.Property[0].TopColor_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Bottom Color:</span>
                                      <p>{chainreport.Property[0].BottomColor_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Quantity:</span>
                                      <p>{chainreport.Property[0].Quantity}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell" colSpan="3">
                                      <span className='prop-td'>Misc Description:</span>
                                      <p>{chainreport.Property[0].Description}</p>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </fieldset>
                          </div>
                          <div className="release-info">
                            <fieldset>
                              <legend className='prop-legend'>Chain Of Custody Information</legend>
                              <table className="table table-bordered mt-3">
                                <thead className='text-dark master-table'>
                                  <tr>
                                    <th className=''>Incident No.</th>
                                    <th className=''>Activity Date/Time</th>
                                    <th className=''>Activity Type</th>
                                    <th className=''>Officer</th>
                                    <th className=''>Property Room Person</th>
                                    <th className=''>Location/Reason</th>
                                    <th className=''>Destroyed Date/Time</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {chainreport.PropertyRoom.map((item, index) => (
                                    <tr key={index}>
                                      <td className='text-list'>{item.IncidentNumber1}</td>
                                      <td className='text-list'>{item.ReceiveDate || 'N/A'}</td>
                                      <td className='text-list'>{item.ActivityReason_Des}</td>
                                      <td className='text-list'>{item.Officer_Name}</td>
                                      <td className='text-list'>{item.PropertyRoomPerson_Name || 'N/A'}</td>
                                      <td className='text-list'>{item.location || 'N/A'}</td>
                                      <td className='text-list'>{item.DestroyDate || 'N/A'}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </fieldset>
                          </div>
                        </>

                      )}

                      {/* Boat info */}

                      {chainreport.Property[0].Type === 'Boat' && (
                        <>
                          <div className="property-info px-0">
                            <fieldset>
                              <legend className='prop-legend px-0'>Evidence Property Information</legend>
                              <table className="table table-bordered mt-3">
                                <tbody>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Property No:</span>
                                      <p>{chainreport.Property[0].PropertyNumber}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Property Type:</span>
                                      <p>{chainreport.Property[0].Type}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Reported Date:</span>
                                      <p>{chainreport.Property[0].ReportedDtTm}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Incident No:</span>
                                      <p>{chainreport.Property[0].IncidentNumber}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Loss Code:</span>
                                      <p>{chainreport.Property[0].LossCode_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Owner Name:</span>
                                      <p>{chainreport.Property[0].OwnerDescription || 'N/A'}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Category:</span>
                                      <p>{chainreport.Property[0].Category_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Classification:</span>
                                      <p>{chainreport.Property[0].Classification_Description || 'N/A'}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Brand:</span>
                                      <p>{chainreport.Property[0].Brand}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Top Color:</span>
                                      <p>{chainreport.Property[0].TopColor_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Bottom Color:</span>
                                      <p>{chainreport.Property[0].BottomColor_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Quantity:</span>
                                      <p>{chainreport.Property[0].Quantity}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell" colSpan="3">
                                      <span className='prop-td'>Misc Description:</span>
                                      <p>{chainreport.Property[0].Description}</p>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </fieldset>
                          </div>
                          <div className="release-info">
                            <fieldset>
                              <legend className='prop-legend'>Chain Of Custody Information</legend>
                              <table className="table table-bordered mt-3">
                                <thead className='text-dark master-table'>
                                  <tr>
                                    <th className=''>Incident No.</th>
                                    <th className=''>Activity Date/Time</th>
                                    <th className=''>Activity Type</th>
                                    <th className=''>Officer</th>
                                    <th className=''>Property Room Person</th>
                                    <th className=''>Location/Reason</th>
                                    <th className=''>Destroyed Date/Time</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {chainreport.PropertyRoom.map((item, index) => (
                                    <tr key={index}>
                                      <td className='text-list'>{item.IncidentNumber1}</td>
                                      <td className='text-list'>{item.ReceiveDate || 'N/A'}</td>
                                      <td className='text-list'>{item.ActivityReason_Des}</td>
                                      <td className='text-list'>{item.Officer_Name}</td>
                                      <td className='text-list'>{item.PropertyRoomPerson_Name || 'N/A'}</td>
                                      <td className='text-list'>{item.location || 'N/A'}</td>
                                      <td className='text-list'>{item.DestroyDate || 'N/A'}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </fieldset>
                          </div>
                        </>

                      )}

                      {/* Drug info */}

                      {chainreport.Property[0].Type === 'Drug' && (
                        <>
                          <div className="property-info px-0">
                            <fieldset>
                              <legend className='prop-legend px-0'>Evidence Property Information</legend>
                              <table className="table table-bordered mt-3">
                                <tbody>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Property No:</span>
                                      <p>{chainreport.Property[0].PropertyNumber}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Property Type:</span>
                                      <p>{chainreport.Property[0].Type}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Reported Date:</span>
                                      <p>{chainreport.Property[0].ReportedDtTm}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Incident No:</span>
                                      <p>{chainreport.Property[0].IncidentNumber}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Loss Code:</span>
                                      <p>{chainreport.Property[0].LossCode_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Owner Name:</span>
                                      <p>{chainreport.Property[0].OwnerDescription || 'N/A'}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Category:</span>
                                      <p>{chainreport.Property[0].Category_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Classification:</span>
                                      <p>{chainreport.Property[0].Classification_Description || 'N/A'}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Brand:</span>
                                      <p>{chainreport.Property[0].Brand}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Top Color:</span>
                                      <p>{chainreport.Property[0].TopColor_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Bottom Color:</span>
                                      <p>{chainreport.Property[0].BottomColor_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Quantity:</span>
                                      <p>{chainreport.Property[0].Quantity}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell" colSpan="3">
                                      <span className='prop-td'>Misc Description:</span>
                                      <p>{chainreport.Property[0].Description}</p>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </fieldset>
                          </div>
                          <div className="release-info">
                            <fieldset>
                              <legend className='prop-legend'>Chain Of Custody Information</legend>
                              <table className="table table-bordered mt-3">
                                <thead className='text-dark master-table'>
                                  <tr>
                                    <th className=''>Incident No.</th>
                                    <th className=''>Activity Date/Time</th>
                                    <th className=''>Activity Type</th>
                                    <th className=''>Officer</th>
                                    <th className=''>Property Room Person</th>
                                    <th className=''>Location/Reason</th>
                                    <th className=''>Destroyed Date/Time</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {chainreport.PropertyRoom.map((item, index) => (
                                    <tr key={index}>
                                      <td className='text-list'>{item.IncidentNumber1}</td>
                                      <td className='text-list'>{item.ReceiveDate || 'N/A'}</td>
                                      <td className='text-list'>{item.ActivityReason_Des}</td>
                                      <td className='text-list'>{item.Officer_Name}</td>
                                      <td className='text-list'>{item.PropertyRoomPerson_Name || 'N/A'}</td>
                                      <td className='text-list'>{item.location || 'N/A'}</td>
                                      <td className='text-list'>{item.DestroyDate || 'N/A'}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </fieldset>
                          </div>
                        </>

                      )}
                      {/* Other info */}

                      {chainreport.Property[0].Type === 'Other' && (
                        <>
                          <div className="property-info px-0">
                            <fieldset>
                              <legend className='prop-legend px-0'>Evidence Property Information</legend>
                              <table className="table table-bordered mt-3">
                                <tbody>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Property No:</span>
                                      <p>{chainreport.Property[0].PropertyNumber}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Property Type:</span>
                                      <p>{chainreport.Property[0].Type}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Reported Date:</span>
                                      <p>{chainreport.Property[0].ReportedDtTm}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Incident No:</span>
                                      <p>{chainreport.Property[0].IncidentNumber}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Loss Code:</span>
                                      <p>{chainreport.Property[0].LossCode_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Owner Name:</span>
                                      <p>{chainreport.Property[0].OwnerDescription || 'N/A'}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Category:</span>
                                      <p>{chainreport.Property[0].Category_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Classification:</span>
                                      <p>{chainreport.Property[0].Classification_Description || 'N/A'}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Brand:</span>
                                      <p>{chainreport.Property[0].Brand}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Top Color:</span>
                                      <p>{chainreport.Property[0].TopColor_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Bottom Color:</span>
                                      <p>{chainreport.Property[0].BottomColor_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Quantity:</span>
                                      <p>{chainreport.Property[0].Quantity}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell" colSpan="3">
                                      <span className='prop-td'>Misc Description:</span>
                                      <p>{chainreport.Property[0].Description}</p>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </fieldset>
                          </div>
                          <div className="release-info">
                            <fieldset>
                              <legend className='prop-legend'>Chain Of Custody Information</legend>
                              <table className="table table-bordered mt-3">
                                <thead className='text-dark master-table'>
                                  <tr>
                                    <th className=''>Incident No.</th>
                                    <th className=''>Activity Date/Time</th>
                                    <th className=''>Activity Type</th>
                                    <th className=''>Officer</th>
                                    <th className=''>Property Room Person</th>
                                    <th className=''>Location/Reason</th>
                                    <th className=''>Destroyed Date/Time</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {chainreport.PropertyRoom.map((item, index) => (
                                    <tr key={index}>
                                      <td className='text-list'>{item.IncidentNumber1}</td>
                                      <td className='text-list'>{item.ReceiveDate || 'N/A'}</td>
                                      <td className='text-list'>{item.ActivityReason_Des}</td>
                                      <td className='text-list'>{item.Officer_Name}</td>
                                      <td className='text-list'>{item.PropertyRoomPerson_Name || 'N/A'}</td>
                                      <td className='text-list'>{item.location || 'N/A'}</td>
                                      <td className='text-list'>{item.DestroyDate || 'N/A'}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </fieldset>
                          </div>
                        </>

                      )}


                      {/* Security info */}

                      {chainreport.Property[0].Type === 'Security' && (
                        <>
                          <div className="property-info px-0">
                            <fieldset>
                              <legend className='prop-legend px-0'>Evidence Property Information</legend>
                              <table className="table table-bordered mt-3">
                                <tbody>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Property No:</span>
                                      <p>{chainreport.Property[0].PropertyNumber}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Property Type:</span>
                                      <p>{chainreport.Property[0].Type}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Reported Date:</span>
                                      <p>{chainreport.Property[0].ReportedDtTm}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Incident No:</span>
                                      <p>{chainreport.Property[0].IncidentNumber}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Loss Code:</span>
                                      <p>{chainreport.Property[0].LossCode_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Owner Name:</span>
                                      <p>{chainreport.Property[0].OwnerDescription || 'N/A'}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Category:</span>
                                      <p>{chainreport.Property[0].Category_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Classification:</span>
                                      <p>{chainreport.Property[0].Classification_Description || 'N/A'}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Brand:</span>
                                      <p>{chainreport.Property[0].Brand}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Top Color:</span>
                                      <p>{chainreport.Property[0].TopColor_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Bottom Color:</span>
                                      <p>{chainreport.Property[0].BottomColor_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Quantity:</span>
                                      <p>{chainreport.Property[0].Quantity}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell" colSpan="3">
                                      <span className='prop-td'>Misc Description:</span>
                                      <p>{chainreport.Property[0].Description}</p>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </fieldset>
                          </div>
                          <div className="release-info">
                            <fieldset>
                              <legend className='prop-legend'>Chain Of Custody Information</legend>
                              <table className="table table-bordered mt-3">
                                <thead className='text-dark master-table'>
                                  <tr>
                                    <th className=''>Incident No.</th>
                                    <th className=''>Activity Date/Time</th>
                                    <th className=''>Activity Type</th>
                                    <th className=''>Officer</th>
                                    <th className=''>Property Room Person</th>
                                    <th className=''>Location/Reason</th>
                                    <th className=''>Destroyed Date/Time</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {chainreport.PropertyRoom.map((item, index) => (
                                    <tr key={index}>
                                      <td className='text-list'>{item.IncidentNumber1}</td>
                                      <td className='text-list'>{item.ReceiveDate || 'N/A'}</td>
                                      <td className='text-list'>{item.ActivityReason_Des}</td>
                                      <td className='text-list'>{item.Officer_Name}</td>
                                      <td className='text-list'>{item.PropertyRoomPerson_Name || 'N/A'}</td>
                                      <td className='text-list'>{item.location || 'N/A'}</td>
                                      <td className='text-list'>{item.DestroyDate || 'N/A'}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </fieldset>
                          </div>
                        </>

                      )}



                      {/* Weapon info */}


                      {chainreport.Property[0].Type === 'Weapon' && (
                        <>
                          <div className="property-info px-0">
                            <fieldset>
                              <legend className='prop-legend px-0'>Evidence Property Information</legend>
                              <table className="table table-bordered mt-3">
                                <tbody>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Property No:</span>
                                      <p>{chainreport.Property[0].PropertyNumber}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Property Type:</span>
                                      <p>{chainreport.Property[0].Type}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Reported Date:</span>
                                      <p>{chainreport.Property[0].ReportedDtTm}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Incident No:</span>
                                      <p>{chainreport.Property[0].IncidentNumber}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Loss Code:</span>
                                      <p>{chainreport.Property[0].LossCode_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Owner Name:</span>
                                      <p>{chainreport.Property[0].OwnerDescription || 'N/A'}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Category:</span>
                                      <p>{chainreport.Property[0].Category_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Classification:</span>
                                      <p>{chainreport.Property[0].Classification_Description || 'N/A'}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Brand:</span>
                                      <p>{chainreport.Property[0].Brand}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Top Color:</span>
                                      <p>{chainreport.Property[0].TopColor_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Bottom Color:</span>
                                      <p>{chainreport.Property[0].BottomColor_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Quantity:</span>
                                      <p>{chainreport.Property[0].Quantity}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell" colSpan="3">
                                      <span className='prop-td'>Misc Description:</span>
                                      <p>{chainreport.Property[0].Description}</p>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </fieldset>
                          </div>
                          <div className="release-info">
                            <fieldset>
                              <legend className='prop-legend'>Chain Of Custody Information</legend>
                              <table className="table table-bordered mt-3">
                                <thead className='text-dark master-table'>
                                  <tr>
                                    <th className=''>Incident No.</th>
                                    <th className=''>Activity Date/Time</th>
                                    <th className=''>Activity Type</th>
                                    <th className=''>Officer</th>
                                    <th className=''>Property Room Person</th>
                                    <th className=''>Location/Reason</th>
                                    <th className=''>Destroyed Date/Time</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {chainreport.PropertyRoom.map((item, index) => (
                                    <tr key={index}>
                                      <td className='text-list'>{item.IncidentNumber1}</td>
                                      <td className='text-list'>{item.ReceiveDate || 'N/A'}</td>
                                      <td className='text-list'>{item.ActivityReason_Des}</td>
                                      <td className='text-list'>{item.Officer_Name}</td>
                                      <td className='text-list'>{item.PropertyRoomPerson_Name || 'N/A'}</td>
                                      <td className='text-list'>{item.location || 'N/A'}</td>
                                      <td className='text-list'>{item.DestroyDate || 'N/A'}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </fieldset>
                          </div>
                        </>

                      )}
                       {chainreport.Property[0].Type === 'Vehicle' && (
                        <>
                          <div className="property-info px-0">
                            <fieldset>
                              <legend className='prop-legend px-0'>Evidence Property Information</legend>
                              <table className="table table-bordered mt-3">
                                <tbody>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Property No:</span>
                                      <p>{chainreport.Property[0].PropertyNumber}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Property Type:</span>
                                      <p>{chainreport.Property[0].Type}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Reported Date:</span>
                                      <p>{chainreport.Property[0].ReportedDtTm}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Incident No:</span>
                                      <p>{chainreport.Property[0].IncidentNumber}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Loss Code:</span>
                                      <p>{chainreport.Property[0].LossCode_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Owner Name:</span>
                                      <p>{chainreport.Property[0].OwnerDescription || 'N/A'}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Category:</span>
                                      <p>{chainreport.Property[0].Category_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Classification:</span>
                                      <p>{chainreport.Property[0].Classification_Description || 'N/A'}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Brand:</span>
                                      <p>{chainreport.Property[0].Brand}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell">
                                      <span className='prop-td'>Top Color:</span>
                                      <p>{chainreport.Property[0].TopColor_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Bottom Color:</span>
                                      <p>{chainreport.Property[0].BottomColor_Description}</p>
                                    </td>
                                    <td className="table-cell">
                                      <span className='prop-td'>Quantity:</span>
                                      <p>{chainreport.Property[0].Quantity}</p>
                                    </td>
                                  </tr>
                                  <tr className="table-row">
                                    <td className="table-cell" colSpan="3">
                                      <span className='prop-td'>Misc Description:</span>
                                      <p>{chainreport.Property[0].Description}</p>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </fieldset>
                          </div>
                          <div className="release-info">
                            <fieldset>
                              <legend className='prop-legend'>Chain Of Custody Information</legend>
                              <table className="table table-bordered mt-3">
                                <thead className='text-dark master-table'>
                                  <tr>
                                    <th className=''>Incident No.</th>
                                    <th className=''>Activity Date/Time</th>
                                    <th className=''>Activity Type</th>
                                    <th className=''>Officer</th>
                                    <th className=''>Property Room Person</th>
                                    <th className=''>Location/Reason</th>
                                    <th className=''>Destroyed Date/Time</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {chainreport.PropertyRoom.map((item, index) => (
                                    <tr key={index}>
                                      <td className='text-list'>{item.IncidentNumber1}</td>
                                      <td className='text-list'>{item.ReceiveDate || 'N/A'}</td>
                                      <td className='text-list'>{item.ActivityReason_Des}</td>
                                      <td className='text-list'>{item.Officer_Name}</td>
                                      <td className='text-list'>{item.PropertyRoomPerson_Name || 'N/A'}</td>
                                      <td className='text-list'>{item.location || 'N/A'}</td>
                                      <td className='text-list'>{item.DestroyDate || 'N/A'}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </fieldset>
                          </div>
                        </>

                      )}






                    </div>
                  </div>
                </fieldset>
        </div>
      </div>
    </div>
        </div >
      </div >
    </div>
  )
}

export default ChainOfModel